import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/preferences")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/preferences" });
	},
});
